import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'

class ConsultaUsuario extends Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }
    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    <div className="listado" id="menu">
                        <h2 className='tituloAccion'>Consultas</h2>
                        <TableContainer>
                            <Table sx={{minWidth: 500}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell><Link to="./Consultas-Solicitudes">Solicitudes</Link></TableCell>
                                        <TableCell><a href="./Consultas-ControlAsistencia">Control de Asistencia</a></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><a href="./Consultas-DatosPersonales">Datos Personales</a></TableCell>
                                        <TableCell><a href="./Consultas-Saldos">Resumen de Saldos</a></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell><a href="./Consultas-NivelEducativo">Nivel Educativo</a></TableCell>
                                        <TableCell><a href="./Consultas-MontoRetroactivo">Monto Retroactivo</a></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                :
                    <Redirect to='/login'/>
                }
            </>
        )//Final return
    }//Final render
}

export default ConsultaUsuario